import { useState } from 'react';

const perks = [
  { icon: 'ri-mail-open-line', label: '每周一封深挖周刊' },
  { icon: 'ri-file-shield-2-line', label: '线索优先核验通道' },
  { icon: 'ri-notification-3-line', label: '热点事件时间线推送' },
];

export default function SubscribeCta() {
  const [notice, setNotice] = useState('');

  return (
    <section id="subscribe" className="w-full border-b border-background-200 bg-background-50">
      <div className="mx-auto w-full max-w-[1400px] px-4 py-14 md:px-8 md:py-20">
        <div className="grid grid-cols-1 items-center gap-10 rounded-lg border border-background-200 bg-background-100 p-6 md:p-10 lg:grid-cols-12 lg:p-12">
          <div className="lg:col-span-7">
            <p className="kicker-line text-[11px] font-medium uppercase tracking-[0.28em] text-primary-600">
              Stay Informed
            </p>
            <h2 className="mt-3 font-heading text-2xl font-bold leading-snug text-foreground-950 md:text-[34px]">
              订阅深挖周刊，别让线索停在半路
            </h2>
            <p className="mt-4 max-w-xl text-sm leading-relaxed text-foreground-600 md:text-[15px]">
              每周我们整理一次新的娱乐圈内幕、网红圈潜规则与饭圈操作线索，标注哪些已经核验、哪些仍在观察，
              也会公开说明哪些结论被推翻。
            </p>

            <div className="mt-7 flex flex-col gap-3 sm:flex-row">
              <button
                type="button"
                onClick={() => setNotice('已记录你的订阅意向（演示环境，暂不对外提交）')}
                className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-7 py-3.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
              >
                <i className="ri-mail-line text-base" />
                订阅深挖周刊
              </button>
              <button
                type="button"
                onClick={() => setNotice('线索提交入口已就绪（演示环境，暂不对外提交）')}
                className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-foreground-300 px-7 py-3.5 text-sm font-medium text-foreground-800 transition-colors hover:border-foreground-500 hover:bg-background-50"
              >
                <i className="ri-send-plane-line text-base" />
                匿名提交线索
              </button>
            </div>
            {notice ? (
              <p className="mt-4 w-fit rounded-md bg-accent-100 px-4 py-2 text-xs text-accent-900">{notice}</p>
            ) : null}
          </div>

          <div className="lg:col-span-5">
            <ul className="flex flex-col gap-3">
              {perks.map((perk) => (
                <li
                  key={perk.label}
                  className="flex items-center gap-4 rounded-lg border border-background-200 bg-background-50 px-5 py-4"
                >
                  <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg bg-secondary-100 text-secondary-800">
                    <i className={`${perk.icon} text-xl`} />
                  </span>
                  <span className="text-sm font-medium text-foreground-800">{perk.label}</span>
                  <i className="ri-check-line ml-auto text-lg text-primary-500" />
                </li>
              ))}
            </ul>
            <p className="mt-4 flex items-start gap-2 text-[11px] leading-relaxed text-foreground-500">
              <i className="ri-information-line mt-0.5 text-sm" />
              我们不会转售任何联系方式，源材料默认脱敏保存。
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}